import React from 'react';
import { ContentSection, FormSectionGroup, PageWrap, SectionHeading } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import ShoppingCart from '../../../../components/ShoppingCart/ShoppingCart';
import { getBrandName } from '../../../../config';
import { CustomerDetailsSection } from '../../../../resources/base/models/enums';
import { CustomerDetailsSubmitSection } from '../CustomerDetailsSubmitSection';
import { formGroups } from '../utils';
import { AddressDataForm } from './AddressDataForm';
import { CompanyDataForm } from './CompanyDataForm';
import { ContactDataForm } from './ContactDataForm';
import { FinancialDataForm } from './FinancialDataForm';

const getFormsToRender = () => {
  return formGroups.coCustomer.map((formName) => {
    switch (formName) {
      case CustomerDetailsSection.CONTACT_COCO_INFO:
        return <ContactDataForm key={formName} formName={formName} />;
      case CustomerDetailsSection.ADDRESS_COCO_INFO:
        return <AddressDataForm key={formName} formName={formName} />;
      case CustomerDetailsSection.FINANCIAL_COCO_INFO:
        return <FinancialDataForm key={formName} formName={formName} />;
      case CustomerDetailsSection.COMPANY_COCO_INFO:
        return <CompanyDataForm key={formName} formName={formName} />;
      default:
        return null;
    }
  });
};

export const CoCustomerDetailsForms = () => {
  return (
    <PageWrap>
      <ShoppingCart />
      <ContentSection altBackground={getBrandName().includes('vw')} className="u-pv-none">
        <SectionHeading className="u-mt" level={2}>
          {t('step4:heading:cocontractor')}
        </SectionHeading>
        <FormSectionGroup>{getFormsToRender()}</FormSectionGroup>
      </ContentSection>
      <CustomerDetailsSubmitSection hasCoCustomer isCoCustomer customerType="INDIVIDUAL" />
    </PageWrap>
  );
};
